"use client"

import { FolderKanban } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FolderKanbanIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FolderKanbanIcon = component(Icon)({ as: FolderKanban })
